import React from 'react';
import Header from '../../atoms/Header';
import Footer from '../../atoms/Footer';

/**
 * Home page component with feed
 * @returns {JSX.Element} Home page component
 */
const MainLayout = ({children}) => {

  return (
      <>
        <Header />
        {children}
        <Footer />
      </>
  );
};

export default MainLayout;